export const mutations = {
  SET_ITEMS(state, items) {
    state.items = items;
  },
  SET_CHATBOT(state, chatbot) {
    state.chatbot = chatbot;
  },
  SET_TOTAL(state, total) {
    state.total = total;
  },
  SET_CURRENT_PAGE(state, currentPage) {
    state.currentPage = currentPage;
  },
  REMOVE_ITEM(state, id) {
    const indexItem = state.items.findIndex(item => item.id === id);
    if (indexItem > -1) {
      state.items.splice(indexItem, 1);
    }
  },
  SET_TOTAL_NODES(state, total) {
    state.totalNodes = total;
  },
};
